import axios from "../utilities/api/axiosInstance";
import { printInConsole } from "@utils/devtools/utils";
import { FEED_TYPES } from "@utils/constants";

export async function getUser({ profileUid, accessToken }) {
  /*
  Returns the user details
  accessToken -> required
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`user?profileUid=${profileUid}`),
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //printInConsole("Profile user data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}
export async function getAuthCheck({ accessToken }) {
  /*
  Returns the user details
  accessToken -> required
  */
  // console.log("accessToken", accessToken);

  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(`authentication/check`),
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //printInConsole("Profile user data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
}
export async function getIPInfo() {
  const response = await axios({
    method: "GET",
    url: encodeURI("https://ipapi.co/json/"),
  }).catch((e) => printInConsole(e));

  if (response?.data) return response.data;

  return null;
}

export async function registerUser({ data, accessToken }) {
  /*
  data --> details of the user  **--{ ?? }--**

  returns the details of the user after successful registration
  */
  //console.log("registerUser", data);
  const response = await axios({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "POST",
    url: encodeURI("user"),
    data: data,
  }).catch((e) => printInConsole(e));

  printInConsole(response);

  if (response?.data) return response.data;

  return null;
}

export const getUserFeeds = async ({
  profileUid,
  postType,
  ts = 0,
  accessToken,
  cancelToken,
}) => {
  /*
  profileUid --> uid of the user whose feed to return
  postType --> constant to indicate "posts"/"clips"
  */

  let params = "";
  if (ts === 0) {
    params = new URLSearchParams({
      profileUid: profileUid,
      postType: postType,
    });
  } else {
    params = new URLSearchParams({
      profileUid: profileUid,
      postType: postType,
      ts: ts,
    });
  }

  const link = "user/feed/v2?" + params;

  const reqOptions = {
    method: "GET",
    url: encodeURI(link),
    cancelToken: cancelToken,
  };

  // if (accessToken) {
  //   reqOptions.headers = {
  //     Authorization: `Bearer ${accessToken}`,
  //   };
  // }

  const result = await axios(reqOptions).catch((err) => printInConsole(err));

  printInConsole("GetUserFeeds => ", result);

  if (result?.data?.success) return result.data.response;

  return [];
};

export async function reportUser({ uid, accessToken }) {
  /*
  uid --> uid of the user to be reported
  Returns true/false
  */

  const response = await axios({
    method: "POST",
    url: encodeURI("user/report"),
    data: { reportedUid: uid },
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Report response => ", response);

  // if (response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function blockUser({ uid, accessToken }) {
  /*
  uid --> uid of the user to be blocked
  returns true/false
  */

  const response = await axios({
    method: "POST",
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    url: encodeURI("user/block"),
    data: { blockedUid: uid },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Block response => ", response);
  // if (response && response?.data) return response.data.success;
  // else return false;
  return response?.data;
}

export async function unBlockUser({ uid, accessToken }) {
  /*
  uid --> uid of the user to be un-blocked
  returns true/false
  */

  const response = await axios({
    method: "DELETE",
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    url: encodeURI("user/block"),
    data: { blockedUid: uid },
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("Un-block response => ", response);

  if (response && response?.data) return response.data.success;
  else return false;
}

export async function getBlockedUser({ uid, ts = 0, accessToken }) {
  /*
  returns the list of users blocked by current user
  */

  let link = null;
  if (ts === 0) link = `user/block?uid=${uid}`;
  else link = `user/block?uid=${uid}&ts=${ts}`;

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(link),
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("GetBlockedUser response => ", response);

  if (response && response?.data) return response.data.response;
  else return [];
}

export const followUser = async ({ uid, accessToken }) => {
  /*
  uid --> uid of the user to be followed
  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("user/follow"),
    data: {
      followedUid: uid,
      headers: { Authorization: `Bearer ${accessToken}` },
    },
  }).catch((err) => printInConsole(err));

  printInConsole("Follow response => ", response);

  // if (response?.data?.success) return response.data;

  // return false;
  return response?.data;
};

export const unFollowUser = async ({ uid, accessToken }) => {
  /*
  uid --> uid of the user to be unfollowed
  returns true/false
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "DELETE",
    url: encodeURI("user/follow"),
    data: { followedUid: uid },
  }).catch((err) => printInConsole(err));

  printInConsole("UnFollow response => ", response);

  // if (response?.data?.success) return response.data;

  // return false;
  return response?.data;
};

export async function getFollowersList({ uid, ts = 0, accessToken }) {
  /*
  returns the list of followers of the user with the uid
  */

  let URL = null;
  if (ts === 0) URL = `user/follow?uid=${uid}`;
  else URL = `user/follow?uid=${uid}&ts=${ts}`;

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(URL),
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("GetFollowersList response => ", response);

  if (response && response?.data) return response.data.response;
  else return [];
}

export const insertDpCover = async ({ dp, accessToken }) => {
  /*
  ----- to be edited ------
  */

  const formdata = new FormData();

  formdata.append("image", dp);
  // formdata.append("uid", uid);
  // formdata.append("caption", caption);
  // formdata.append("isSharing", isSharing);

  const result = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "POST",
    url: encodeURI("user/image"),
    data: formdata,
  }).catch((e) => printInConsole(e));

  printInConsole("Insert UserImage => ", result);

  // if (result?.data?.success && result?.data?.response)
  //   return result.data.response;

  // return null;
  return result?.data;
};

export const updateProfileDp = async ({
  uid,
  image,
  caption,
  isSharing,
  accessToken,
}) => {
  /*
  ----- to be edited ------
  */

  const formdata = new FormData();

  formdata.append("image", image);
  formdata.append("uid", uid);
  if (caption) formdata.append("caption", caption);
  if (typeof isSharing === "boolean") formdata.append("isSharing", isSharing);

  const result = await axios({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "PUT",
    url: encodeURI("user/update/" + FEED_TYPES.DP),
    data: formdata,
  }).catch((e) => printInConsole(e));

  printInConsole("Update Profile pic => ", result);

  // if (result?.data?.success) return result.data.response;

  // return null;
  return result?.data;
};

export const updateCoverPic = async ({
  uid,
  image,
  caption,
  isSharing,
  accessToken,
}) => {
  /*
  ----- to be edited ------
  */

  const formdata = new FormData();

  formdata.append("image", image);
  formdata.append("uid", uid);
  if (caption) formdata.append("caption", caption);
  if (typeof isSharing === "boolean") formdata.append("isSharing", isSharing);

  const result = await axios({
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    method: "PUT",
    url: encodeURI("user/update/" + FEED_TYPES.COVER),
    data: formdata,
  }).catch((e) => printInConsole(e));

  printInConsole("Update Cover pic => ", result);

  // if (result?.data?.success) return result.data.response;

  // return null;
  return result?.data;
};

export const updateUser = async ({ data, accessToken }) => {
  /*
  ----- to be edited ------
  */

  // console.log(data);

  const response = await axios({
    method: "PUT",
    url: encodeURI("user"),
    data: data,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).catch((err) => printInConsole(err));

  printInConsole("UpdateUser => ", response);

  if (response?.data?.success) return response.data;

  return null;
};

export async function getJoinedCommunities({ uid, ts = 0, accessToken }) {
  /*
  returns the list of communities joined by the current user
  */

  if (!accessToken) {
    accessToken = "";
  }
  let URL = null;
  if (uid) {
    if (ts === 0) URL = `user/communities?uid=${uid}`;
    else URL = `user/communities?uid=${uid}&ts=${ts}`;
  } else {
    if (ts === 0) URL = `user/communities`;
    else URL = `user/communities?ts=${ts}`;
  }

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(URL),
  }).catch((err) => {
    printInConsole(err);
  });

  //console.log("GetJoinedCommunities response => ", response);

  if (response && response?.data) return response.data.response;
  else return [];
}

export async function getAdminCommunities({ accessToken, cancelToken }) {
  /*
  returns the list of communities where the current user is admin
  */

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI("user/community/admin"),
    cancelToken: cancelToken,
  }).catch((err) => {
    printInConsole(err);
  });

  printInConsole("GetAdminCommunities response => ", response);

  if (response && response?.data) return response.data.response;
  else return [];
}

export async function getCommunityInvitations({
  ts = 0,
  accessToken,
  cancelToken,
}) {
  /*
  returns the list of communities joined by the current user
  */

  let URL = null;
  if (ts === 0) URL = "community/member/invitations";
  else URL = `community/member/invitations?ts=${ts}`;

  const response = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "GET",
    url: encodeURI(URL),
    cancelToken: cancelToken,
  }).catch((err) => {
    printInConsole(err);
  });

  //printInConsole("GetCommunityInvitations response => ", response);

  if (response && response?.data) return response.data.response;
  else return [];
}

export const updateLanguage = async ({ accessToken, language }) => {
  /*
  ----- to be edited ------
  */
  // formdata.append("uid", uid);
  // formdata.append("caption", caption);
  // formdata.append("isSharing", isSharing);

  const result = await axios({
    // headers: {
    //   Authorization: `Bearer ${accessToken}`,
    // },
    method: "PUT",
    url: encodeURI("user/language"),
    data: { language },
  }).catch((e) => printInConsole(e));

  //console.log("Language updated => ", result);

  if (result?.data?.success && result?.data?.response)
    return result.data.response;

  return null;
};

export const getTransaction = async ({ uid, cancelToken, ts = 0 }) => {
  const url =
    ts === 0
      ? `user/transactions?uid=${uid}`
      : `user/transactions?uid=${uid}&ts=${ts}`;

  const reqOptions = {
    method: "GET",
    url: encodeURI(url),
    cancelToken: cancelToken,
  };

  let err = null;

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  if (response?.data?.success) {
    return { data: response.data.response };
  }

  return { data: null, error: err };
};

export const getCollection = async ({ registrationID }) => {
  let data = null,
    err = null;

  const reqOptions = {
    method: "GET",
    url: encodeURI(
      `community/event/registration/getStatusForUser?registrationID=${registrationID}`
    ),
  };

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //console.log("Event data  => ", response);

  if (response?.data?.success) data = response.data.response;

  return { data, err };
};
export async function updateUserLanguage({ language, accessToken }) {
  /*
  uid --> uid of the user to be blocked
  returns true/false
  */

  let data = null,
    err = null;

  const reqOptions = {
    method: "PUT",
    url: encodeURI("user/language"),
    data: { language },
  };

  if (accessToken) {
    reqOptions.headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const response = await axios(reqOptions).catch((error) => {
    err = error;
    printInConsole(error);
  });

  //printInConsole("Profile user data  => ", response);

  if (response?.data?.success) data = response.data.success;

  return { data, err };
}
